<template>
  <div class="puzzle-article-item">
    <SkeletonItem
      class="puzzle-article-item-photo"
      :is-animated="loading"
    />
    <div class="puzzle-article-item-title">
      <SkeletonItem
        class="puzzle-article-item-header"
        :is-animated="loading"
      />
      <SkeletonItem
        class="puzzle-article-item-subheader"
        :is-animated="loading"
      />
      <SkeletonItem
        class="puzzle-article-item-date"
        :is-animated="loading"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
  import { SkeletonItem } from '@experience/core-skeleton-lib';

  interface Props {
    /**
     * Флаг состояния загрузки.
     */
    loading?: boolean;
  }

  withDefaults(defineProps<Props>(), { loading: false });
</script>

<style lang="scss" scoped>
  .puzzle-article-item {
    display: flex;
    flex-direction: column;
    gap: 16px;
    height: fit-content;
  }

  .puzzle-article-item-title {
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 100%;
    height: min-content;
    color: var(--alias-color-text-default);
    text-decoration: none;

    @include tablet {
      gap: 0;
    }
  }

  .puzzle-article-item-header {
    width: 100%;
    height: 28px;

    @include tablet {
      height: 48px;
    }
  }

  .puzzle-article-item-subheader {
    width: 100%;
    height: 24px;
    margin-top: 8px;

    @include tablet {
      display: none;
    }
  }

  .puzzle-article-item-date {
    width: 36%;
    height: 20px;

    @include tablet {
      width: 50%;
      margin-top: 4px;
    }

    @include mobile {
      width: 80%;
    }
  }

  .puzzle-article-item-photo {
    width: 100%;
    height: 100%;
    border-radius: 8px;

    &:after {
      content: '';
      position: absolute;
      top: 0;
      display: block;
      width: 100%;
      height: 100%;
      border-radius: 8px;
    }

    @include mobile {
      aspect-ratio: 16/10 !important;
    }
  }
</style>
